import { render, staticRenderFns } from "./MapFeatureCollection.vue?vue&type=template&id=40d9c484"
import script from "./MapFeatureCollection.vue?vue&type=script&lang=js"
export * from "./MapFeatureCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports